/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanTaskDto
 */
export interface ExecutionPlanTaskDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    milestoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    parentTaskId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    taskType?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    durationDays?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    earlyStart?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    earlyFinish?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    lateStart?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    lateFinish?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    floatDays?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExecutionPlanTaskDto
     */
    critical?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    plannedStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    plannedEndDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    actualStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    actualEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    ownerUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    estimatedHours?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    actualHours?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    budgetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    actualCost?: number;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof ExecutionPlanTaskDto
     */
    controlRefs?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    sourceCaseId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExecutionPlanTaskDto
     */
    poamItem?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    mandatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    mandateNote?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    mandateCompletionExpectedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    recurringTaskDefinitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    recurringCadenceTier?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    recurringTimezone?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDto
     */
    recurrenceOperatorNotes?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    positionOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDto
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the ExecutionPlanTaskDto interface.
 */
export function instanceOfExecutionPlanTaskDto(value: object): value is ExecutionPlanTaskDto {
    return true;
}

export function ExecutionPlanTaskDtoFromJSON(json: any): ExecutionPlanTaskDto {
    return ExecutionPlanTaskDtoFromJSONTyped(json, false);
}

export function ExecutionPlanTaskDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanTaskDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'milestoneId': json['milestoneId'] == null ? undefined : json['milestoneId'],
        'parentTaskId': json['parentTaskId'] == null ? undefined : json['parentTaskId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'taskType': json['taskType'] == null ? undefined : json['taskType'],
        'durationDays': json['durationDays'] == null ? undefined : json['durationDays'],
        'earlyStart': json['earlyStart'] == null ? undefined : json['earlyStart'],
        'earlyFinish': json['earlyFinish'] == null ? undefined : json['earlyFinish'],
        'lateStart': json['lateStart'] == null ? undefined : json['lateStart'],
        'lateFinish': json['lateFinish'] == null ? undefined : json['lateFinish'],
        'floatDays': json['floatDays'] == null ? undefined : json['floatDays'],
        'critical': json['critical'] == null ? undefined : json['critical'],
        'plannedStartDate': json['plannedStartDate'] == null ? undefined : (new Date(json['plannedStartDate'])),
        'plannedEndDate': json['plannedEndDate'] == null ? undefined : (new Date(json['plannedEndDate'])),
        'actualStartDate': json['actualStartDate'] == null ? undefined : (new Date(json['actualStartDate'])),
        'actualEndDate': json['actualEndDate'] == null ? undefined : (new Date(json['actualEndDate'])),
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'estimatedHours': json['estimatedHours'] == null ? undefined : json['estimatedHours'],
        'actualHours': json['actualHours'] == null ? undefined : json['actualHours'],
        'budgetAmount': json['budgetAmount'] == null ? undefined : json['budgetAmount'],
        'actualCost': json['actualCost'] == null ? undefined : json['actualCost'],
        'controlRefs': json['controlRefs'] == null ? undefined : json['controlRefs'],
        'sourceCaseId': json['sourceCaseId'] == null ? undefined : json['sourceCaseId'],
        'poamItem': json['poamItem'] == null ? undefined : json['poamItem'],
        'mandatedBy': json['mandatedBy'] == null ? undefined : json['mandatedBy'],
        'mandateNote': json['mandateNote'] == null ? undefined : json['mandateNote'],
        'mandateCompletionExpectedAt': json['mandateCompletionExpectedAt'] == null ? undefined : (new Date(json['mandateCompletionExpectedAt'])),
        'recurringTaskDefinitionId': json['recurringTaskDefinitionId'] == null ? undefined : json['recurringTaskDefinitionId'],
        'recurringCadenceTier': json['recurringCadenceTier'] == null ? undefined : json['recurringCadenceTier'],
        'recurringTimezone': json['recurringTimezone'] == null ? undefined : json['recurringTimezone'],
        'recurrenceOperatorNotes': json['recurrenceOperatorNotes'] == null ? undefined : json['recurrenceOperatorNotes'],
        'positionOrder': json['positionOrder'] == null ? undefined : json['positionOrder'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ExecutionPlanTaskDtoToJSON(json: any): ExecutionPlanTaskDto {
    return ExecutionPlanTaskDtoToJSONTyped(json, false);
}

export function ExecutionPlanTaskDtoToJSONTyped(value?: ExecutionPlanTaskDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'planId': value['planId'],
        'milestoneId': value['milestoneId'],
        'parentTaskId': value['parentTaskId'],
        'name': value['name'],
        'description': value['description'],
        'status': value['status'],
        'taskType': value['taskType'],
        'durationDays': value['durationDays'],
        'earlyStart': value['earlyStart'],
        'earlyFinish': value['earlyFinish'],
        'lateStart': value['lateStart'],
        'lateFinish': value['lateFinish'],
        'floatDays': value['floatDays'],
        'critical': value['critical'],
        'plannedStartDate': value['plannedStartDate'] == null ? undefined : ((value['plannedStartDate']).toISOString().substring(0,10)),
        'plannedEndDate': value['plannedEndDate'] == null ? undefined : ((value['plannedEndDate']).toISOString().substring(0,10)),
        'actualStartDate': value['actualStartDate'] == null ? undefined : ((value['actualStartDate']).toISOString().substring(0,10)),
        'actualEndDate': value['actualEndDate'] == null ? undefined : ((value['actualEndDate']).toISOString().substring(0,10)),
        'ownerUserId': value['ownerUserId'],
        'estimatedHours': value['estimatedHours'],
        'actualHours': value['actualHours'],
        'budgetAmount': value['budgetAmount'],
        'actualCost': value['actualCost'],
        'controlRefs': value['controlRefs'],
        'sourceCaseId': value['sourceCaseId'],
        'poamItem': value['poamItem'],
        'mandatedBy': value['mandatedBy'],
        'mandateNote': value['mandateNote'],
        'mandateCompletionExpectedAt': value['mandateCompletionExpectedAt'] == null ? undefined : ((value['mandateCompletionExpectedAt']).toISOString()),
        'recurringTaskDefinitionId': value['recurringTaskDefinitionId'],
        'recurringCadenceTier': value['recurringCadenceTier'],
        'recurringTimezone': value['recurringTimezone'],
        'recurrenceOperatorNotes': value['recurrenceOperatorNotes'],
        'positionOrder': value['positionOrder'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

